var React = require('react');

function Np2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.60038 33.7179L15.025 23.324C20.5635 18.6533 22.5388 16.0133 22.5388 12.4502C22.5388 8.4625 19.6773 6.24712 16.1142 6.24712C12.7912 6.24712 10.5758 7.79788 8.13885 10.6963C7.47423 11.361 6.82808 11.7856 5.49885 11.7856C3.72654 11.7856 2.39731 10.4748 2.39731 8.68404C2.39731 7.79788 2.60038 7.13327 3.06192 6.48711C6.385 2.49942 10.1512 0.0625 16.5758 0.0625C24.5512 0.0625 29.8681 4.69635 29.8681 12.0256C29.8681 18.2102 26.5265 21.7733 19.4558 27.5148L11.0373 34.401H27.4312C29.2035 34.401 30.5327 35.7302 30.5327 37.5025C30.5327 39.0533 29.2035 40.604 27.4312 40.604H4.61269C2.39731 40.604 0.625 39.2563 0.625 37.281C0.625 35.7302 1.28962 34.604 2.60038 33.7179Z","fill":"white"}));
}

Np2.defaultProps = {"width":"31","height":"41","viewBox":"0 0 31 41"};

module.exports = Np2;

Np2.default = Np2;
